import { wrapMethodsWithLogging } from "components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "repositories/api/BaseApiRepository";

class Repository {

    static async getStations() {
        return await BaseApiRepository.getAsync(`pilot-station`);
    }

    static async getStationsPreferences() {
        return await BaseApiRepository.getAsync(`pilot-station/preferences`);
    }

    static async getPreferencesFavouriteStations() {
        return await BaseApiRepository.getAsync(`pilot-station/preferences/favourites`);
    }

    static async setPreferencesFavouriteStation(station:any) {
        return await BaseApiRepository.putAsync(`pilot-station/preferences/favourites`, station);
    }

    static async getStationOverView(id:number) {
        return await BaseApiRepository.getAsync(`pilot-station/${id}`);
    }
};
wrapMethodsWithLogging(Repository);

export default Repository;
